import React, { useState, useEffect, useRef } from "react";
import SubscriptionPricingCard from "../../Seller-Owner/Components/SubscriptionPricingCard";
import "../styles/PlainTimerPage.css";
import { sellerDashboardAPI } from "../../services/api.service";

const PlainTimerPage = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [loading, setLoading] = useState(true);
  const [showCountdown, setShowCountdown] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const fetchAndStartTimer = async () => {
      const clearTimer = () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
      };

      try {
        const response = await sellerDashboardAPI.getStats();
        const endRaw = response.success ? response.data?.subscription?.end_date : null;

        clearTimer();

        if (endRaw) {
          const endDate = new Date(endRaw);
          if (!isNaN(endDate.getTime()) && endDate.getTime() > Date.now()) {
            setShowCountdown(true);
            timerRef.current = setInterval(() => {
              const now = new Date().getTime();
              const distance = endDate.getTime() - now;

              if (distance < 0) {
                clearTimer();
                setShowCountdown(false);
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
              } else {
                setTimeLeft({
                  days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                  hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                  minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                  seconds: Math.floor((distance % (1000 * 60)) / 1000)
                });
              }
            }, 1000);
          } else {
            setShowCountdown(false);
            setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          }
        } else {
          setShowCountdown(false);
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
      } catch (err) {
        console.error('Error fetching subscription data:', err);
        clearTimer();
        setShowCountdown(false);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } finally {
        setLoading(false);
      }
    };

    fetchAndStartTimer();

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  if (loading) {
    return (
      <div className="seller-timer-page">
        <div className="seller-timer-content">
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>Loading subscription data...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="seller-timer-page">
      <div className="seller-timer-content">
        <div className="seller-timer-badge">
          SUBSCRIPTION
        </div>

        <h1 className="seller-timer-title">
          <span className="seller-timer-title-purple">Agent plans</span>
          <br />
          <span className="seller-timer-title-white">Manage subscriptions from your dashboard</span>
        </h1>

        {showCountdown ? (
          <div className="seller-timer-card">
            <div className="seller-timer-header">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                className="seller-timer-clock-icon"
              >
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <h2>Current plan ends in</h2>
            </div>

            <div className="seller-timer-display">
              {["days", "hours", "minutes", "seconds"].map((unit, idx) => (
                <React.Fragment key={unit}>
                  <div className="seller-timer-time-block">
                    <div className="seller-timer-time-box">{String(timeLeft[unit]).padStart(2, "0")}</div>
                    <div className="seller-timer-time-label">{unit.toUpperCase()}</div>
                  </div>
                  {idx < 3 && <div className="seller-timer-separator">:</div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        ) : (
          <div className="seller-timer-card" style={{ textAlign: 'center', padding: '1.5rem' }}>
            <p style={{ margin: 0, lineHeight: 1.5 }}>
              No active subscription period is linked to this account. You can still use agent listing features; subscribe here if you need a paid plan.
            </p>
          </div>
        )}

        <div className="seller-timer-pricing-section">
          <h2 className="seller-timer-pricing-heading">Plans &amp; pricing</h2>
          <SubscriptionPricingCard subscriptionPath="/seller-dashboard/plans" variant="page" />
        </div>
      </div>
    </div>
  );
};

export default PlainTimerPage;
